/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ThreadRating } from '@squiz/dxp-ai-client';
import { SdsIcon } from '@squiz/sds';
import { ICON_THUMB_DOWN_TWO_TONE, ICON_THUMB_UP_TWO_TONE } from 'libs/sds/src/Icons';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AI_STRINGS } from '../../../Constants/Strings.constants';

export type ThreadRatingWithIconProps = {
  rating: ThreadRating | null;
};

export const ThreadRatingWithIcon = (props: ThreadRatingWithIconProps): JSX.Element => {
  const { rating } = props;
  const { t } = useTranslation();
  const labels = useMemo(() => {
    return {
      negative: t(AI_STRINGS.negative),
      positive: t(AI_STRINGS.positive),
    };
  }, [t]);
  if (rating === null) {
    return <span>-</span>;
  }
  return rating === 'positive' ? (
    <div className="ai-thread-rating ai-thread-rating__positive">
      <SdsIcon svg={ICON_THUMB_UP_TWO_TONE}></SdsIcon>
      <span>{labels.positive}</span>
    </div>
  ) : (
    <div className="ai-thread-rating ai-thread-rating__negative">
      <SdsIcon svg={ICON_THUMB_DOWN_TWO_TONE}></SdsIcon>
      <span>{labels.negative}</span>
    </div>
  );
};
